import * as Cookies from 'js-cookie';
import { CookiesAgreement } from './CookiesAgreement/CookiesAgreement';
import { Collapse } from './Collapse/Collapse';
import { LitPopupElement } from './LitPopupElement/LitPopupElement';
import { Tabs } from './Tabs/Tabs';
import { WebShare } from './WebShare/WebShare';

export function initCustomElements() {
    if (Cookies.get('COOKIES_USAGE_ACCEPTED') !== 'true') {
        customElements.define('app-cookies-agreement', CookiesAgreement);
    }

    customElements.define('app-collapse', Collapse);
    customElements.define('app-lit-popup', LitPopupElement);
    customElements.define('app-tabs', Tabs);
    customElements.define('app-web-share', WebShare);
}
